import { Pipe, PipeTransform } from '@angular/core';
import { MainService } from 'src/app/services/main.service';

@Pipe({
  name: 'noDecimal'
})
export class NoDecimalPipe implements PipeTransform {
  constructor(private ms: MainService) { }
  transform(val: number): string {
    if (val !== undefined && val !== null) {
      // here we just remove the commas from value
      return Number(val.toString().replace(',', '')).toFixed(this.ms.CommonSetting.NoOfDecimal);
    } else {
      return '';
    }
  }
}
